<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DashboardLayout from '@/layouts/DashboardLayout.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import WizardLayout from '@/layouts/WizardLayout.vue'

const route = useRoute()

const layout = computed(() => {
  return route.meta.layout as string | undefined
})
</script>

<template>
  <WizardLayout v-if="layout === 'wizard'">
    <RouterView />
  </WizardLayout>
  <AdminLayout v-else-if="layout === 'admin'">
    <RouterView />
  </AdminLayout>
  <DashboardLayout v-else-if="layout === 'dashboard'">
    <RouterView />
  </DashboardLayout>
  <AuthLayout v-else-if="layout === 'auth'">
    <RouterView />
  </AuthLayout>
  <RouterView v-else />
</template>
